import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import isArray from 'utils/validation/isArray'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'

function renderDentalVisionDetails(plans) {
  if (isArray(plans) && plans.length > 0) {
    const templateDetails = Templater(getById('template-addOn-details').innerText)
    innerHTML('#addOn-details-wrap', templateDetails({ plans }))
  }
}

export default renderDentalVisionDetails
